
import { defineComponent, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";

export default defineComponent({
  name: "block-mohon",
  components: {},
  setup() {
    const route = useRoute();
    const router = useRouter();
    const data = reactive({
      id: 0,
      code: "",
      title: "",
      message: "",
      siri: 0,
      tahun: 0,
    });

    if (!route.params.data) router.push({ path: "/" });
    else {
      const params = JSON.parse(route.params.data as string);
      data.id = params.data.id;
      data.title = params.data.tajuk_peperiksaan;
      data.message = params.msg;
      data.siri = params.data.siri_peperiksaan;
      data.tahun = params.data.tahun_peperiksaan;
      data.code = params.data.code;
    }

    return { data };
  },
});
